// @flow

import groupBy from 'lodash/groupBy';
import moment from 'moment';
import type { SessionType, SessionsType } from 'types/sessions';

type GroupedSessionsType = {
  pastSessions?: SessionType[],
  futureSessions?: SessionType[],
};

const groupSessionsByEndTime = (sessions: SessionsType): GroupedSessionsType =>
  groupBy(
    sessions,
    ({ attributes: { endTime } }: SessionType): 'pastSessions' | 'futureSessions' =>
      moment(endTime).isBefore() ? 'pastSessions' : 'futureSessions',
  );

export default groupSessionsByEndTime;



// WEBPACK FOOTER //
// ./src/screens/sessions/list/helpers.js